import classes from './ReceiptsView.scss';
import React, { Component } from 'react';
import { fromJS } from 'immutable';
import { Col, Row } from 'react-flexbox-grid/lib/index';
import moment from 'moment';
import Checkbox from 'material-ui/Checkbox';

class CustomerOrderReceiptView extends Component {
    formatDateWithTime(date) {
        if (!date) {
            return '';
        }
        return moment(date).format('DD.MM.YYYY');
    }

    render = () => {
        const itemNodes = this.props.receipt
            .getIn(['customer_order_items'], fromJS([]))
            .map(item => {
                return (
                    <div className={classes.customer_order}>
                        <CustomerOrderRow>
                            <Col xs>Kundenname</Col>
                            <Col xs>{item.get('customer_name')}</Col>
                        </CustomerOrderRow>
                        <CustomerOrderRow>
                            <Col xs>Kundennummer</Col>
                            <Col xs>{item.get('customer_id')}</Col>
                        </CustomerOrderRow>
                        <CustomerOrderRow>
                            <Col xs>Artikelnummer</Col>
                            <Col xs>{item.get('ean')}</Col>
                        </CustomerOrderRow>
                        <CustomerOrderRow>
                            <Col xs>Artikelname</Col>
                            <Col xs>{item.get('item_name')}</Col>
                        </CustomerOrderRow>
                        <h5>Kontakt</h5>
                        <CustomerOrderRow>
                            <Col xs>Telefon</Col>
                            <Col xs>{item.get('customer_phone')}</Col>
                        </CustomerOrderRow>
                        <CustomerOrderRow>
                            <Col xs>E-Mail</Col>
                            <Col xs>{item.get('customer_email')}</Col>
                        </CustomerOrderRow>
                        <CustomerOrderRow>
                            <Col xs>Informieren über</Col>
                            <Col xs>
                                <CustomerOrderRow>
                                    <Col xs={1}>
                                        <Checkbox checked={item.get('notify_via_phone')} />
                                    </Col>
                                    <Col xs={11}>TELEFON</Col>
                                </CustomerOrderRow>
                                <CustomerOrderRow>
                                    <Col xs={1}>
                                        <Checkbox checked={item.get('notify_via_whatsapp')} />
                                    </Col>
                                    <Col xs={11}>WHATSAPP</Col>
                                </CustomerOrderRow>
                                <CustomerOrderRow>
                                    <Col xs={1}>
                                        <Checkbox checked={item.get('notify_via_sms')} />
                                    </Col>
                                    <Col xs={11}>SMS</Col>
                                </CustomerOrderRow>
                                <CustomerOrderRow>
                                    <Col xs={1}>
                                        <Checkbox checked={item.get('notify_via_email')} />
                                    </Col>
                                    <Col xs={11}>E-MAIL</Col>
                                </CustomerOrderRow>
                            </Col>
                        </CustomerOrderRow>
                        <CustomerOrderRow>
                            <Col xs>Bemerkungen</Col>
                            <Col xs>{item.get('notes')}</Col>
                        </CustomerOrderRow>
                    </div>
                );
            });

        return (
            <div>
                <Row className={classes.headline}>
                    <Col className={classes.column} xs={3}>
                        <strong>Filiale</strong>
                        <br />
                        {this.props.receipt.get('branch')}
                    </Col>
                    <Col className={classes.column} xs={3}>
                        <strong>Erfasser</strong>
                        <br />
                        {this.props.receipt.get('user')}
                    </Col>
                    <Col className={classes.column} xs={3}>
                        <strong>Datum</strong>
                        <br />
                        {this.formatDateWithTime(this.props.receipt.get('date'))}
                    </Col>
                </Row>
                {itemNodes}
            </div>
        );
    };
}

export default CustomerOrderReceiptView;

class CustomerOrderRow extends Component {
    render = () => {
        return <Row className={classes.row}>{this.props.children}</Row>;
    };
}
